
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{staticClass:"color",attrs:{"width":"38","height":"38","rx":"2","fill":"#A3A3A3"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.585 18.02c.553.542.553 1.418 0 1.96l-4.722 4.614a1.44 1.44 0 01-2.004 0 1.363 1.363 0 010-1.958l2.304-2.251H11.417c-.783 0-1.417-.62-1.417-1.385s.634-1.385 1.417-1.385h10.746l-2.304-2.251a1.363 1.363 0 010-1.959 1.44 1.44 0 012.004 0l4.722 4.616z","fill":"#EDEDED"}})])
          )
        }
      }
    